import styled from "styled-components";
import { Colors, TextFont } from "../../config";
import { HeaderWrapper } from "../../pages/ConfirmBookingStatus";

const PerDiemDetails = ({}) => {
  return (
    <>
      <HeaderWrapper>
        <TextFont fontColor={Colors.white} fontSize="1rem" fontWeight="600">
          Per Diem Details
        </TextFont>
      </HeaderWrapper>
      <div
        style={{
          padding: "1.2rem",
          boxSizing: "border-box",
          background: Colors.white,
          borderRadius: "1rem",
        }}
      >
        <ColumnWrapper>
          <Item>
            <Header>Selected Benefit</Header>
            <Value>Business Trip PerDiem</Value>
          </Item>
          <Item>
            <Header>Claim Amount</Header>
            <Value>1,720.20 QAR</Value>
          </Item>
          <Item>
            <Header>Submission Date</Header>
            <Value>09 Nov 2024</Value>
          </Item>
          <Item>
            <Header>Status</Header>
            <Value>In Progress</Value>
          </Item>
        </ColumnWrapper>
      </div>
    </>
  );
};

const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const Item = styled.div`
  width: 25%;
`;

const WideItem = styled.div`
  width: 100%;
`;

const Header = styled.div`
  color: rgb(142, 142, 161);
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 4px;
`;

const Value = styled.div`
  color: rgb(34, 36, 44);
  font-size: 14px;
  font-weight: 500;
  // margin-bottom: 16px;
`;

export default PerDiemDetails;
